import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Card, CardContent } from '../ui/card';
import { Plus, Trash2 } from 'lucide-react';

export function RepeatableFieldArray({ label, items, onItemsChange, fieldConfig, addLabel }) {
  // addLabel overrides the auto-singularised button text (label.slice(0,-1) breaks on
  // irregular plurals like "Properties" -> "Propertie").
  const addItem = () => {
    const newItem = {};
    fieldConfig.forEach(field => {
      newItem[field.name] = '';
    });
    onItemsChange([...items, newItem]);
  };

  const removeItem = (index) => {
    onItemsChange(items.filter((_, i) => i !== index));
  };

  const updateItem = (index, fieldName, value) => {
    const updated = [...items];
    updated[index] = { ...updated[index], [fieldName]: value };
    onItemsChange(updated);
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <Label className="text-base font-semibold">{label}</Label>
        <Button type="button" onClick={addItem} size="sm" variant="outline">
          <Plus className="w-4 h-4 mr-2" />
          {addLabel || `Add ${label.slice(0, -1)}`}
        </Button>
      </div>

      {items.length === 0 ? (
        <p className="text-sm text-muted-foreground">No {label.toLowerCase()} added yet. Click "Add" to begin.</p>
      ) : (
        <div className="space-y-3">
          {items.map((item, index) => (
            <Card key={index} className="bg-muted/50">
              <CardContent className="pt-4">
                <div className="flex items-start justify-between mb-3">
                  <span className="text-sm font-medium text-foreground/90">
                    {label.slice(0, -1)} {index + 1}
                  </span>
                  <Button
                    type="button"
                    onClick={() => removeItem(index)}
                    size="sm"
                    variant="ghost"
                    className="text-red-600 hover:text-red-700"
                  >
                    <Trash2 className="w-4 h-4" />
                  </Button>
                </div>

                <div className="grid grid-cols-2 gap-3">
                  {fieldConfig.map((field) => (
                    <div key={field.name} className="space-y-1">
                      <Label className="text-xs">
                        {field.label}
                        {field.required && <span className="text-red-500 ml-1">*</span>}
                      </Label>
                      <Input
                        type={field.type || 'text'}
                        placeholder={field.placeholder || ''}
                        value={item[field.name] || ''}
                        onChange={(e) => updateItem(index, field.name, e.target.value)}
                        required={field.required}
                        maxLength={field.maxLength}
                        className={field.type === 'number' || field.name.includes('bsb') || field.name.includes('tfn') || field.name.includes('abn') ? 'font-mono' : ''}
                      />
                    </div>
                  ))}
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
